import { render, staticRenderFns } from "./RequestAssessment.vue?vue&type=template&id=a0d6a106"
import script from "./RequestAssessment.vue?vue&type=script&lang=js"
export * from "./RequestAssessment.vue?vue&type=script&lang=js"
import style0 from "./RequestAssessment.vue?vue&type=style&index=0&id=a0d6a106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports